module.exports = __webpack_public_path__ + "img/gsjj-banner-pic.fd351b41.png";